import React from "react";

const SOE = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_11285_4420)">
        <path
          d="M12.81 17.9103L11.15 19.6003C10.71 20.0403 10.18 20.4004 9.59998 20.6404C9.01998 20.8804 8.40003 21.0004 7.78003 21.0004C7.16003 21.0004 6.53001 20.8804 5.95001 20.6404C5.37001 20.4004 4.84002 20.0503 4.40002 19.6003C3.96002 19.1603 3.59999 18.6304 3.35999 18.0504C3.11999 17.4704 3 16.8503 3 16.2203C3 15.5903 3.11999 14.9704 3.35999 14.3904C3.59999 13.8104 3.96002 13.2804 4.40002 12.8404L6.08002 11.1504"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M11.1504 6.09003L12.8404 4.40002C13.7404 3.51002 14.9503 3 16.2203 3C17.4903 3 18.7003 3.50002 19.6003 4.40002C20.4903 5.30002 21.0004 6.51003 21.0004 7.78003C21.0004 9.05003 20.4903 10.26 19.6003 11.16L17.9103 12.85"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M8.58008 15.3799L15.3401 8.62988"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_11285_4420">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SOE;
